import React from 'react';

import { Container, Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Icon from './Icon';

import { useRef, useEffect } from 'react';
import { register } from 'swiper/element/bundle';

register();

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/element/css/autoplay';

const FlaivySwiper = props => {
  const swiperElRef = useRef(null);

  useEffect(() => {
    if (!swiperElRef.current) return;
    // listen for Swiper events using addEventListener
    swiperElRef.current.addEventListener('progress', e => {
      const [swiper, progress] = e.detail;
    });

    swiperElRef.current.addEventListener('slidechange', e => {});
  }, []);

  const breakpoints = [];

  const params = {
    containerClass: 'swiper-container',
    slidesPerView: props.slidesPerView,
    effect: props.effect,
    allowTouchMove: !!props.allowTouchMove,
    spaceBetween: props.spaceBetween,
    centeredSlides: props.centeredSlides,
    roundLengths: props.roundLengths,
    loop: props.loop,
    speed: props.speed ? props.speed : 400,
    parallax: props.parallax,
    breakpoints,
    pagination: true,
    wrapperClass: 'swiper-wrapper',
  };

  if (props.autoplay) {
    params.autoplay = true;
    params.autoplayDelay = props.delay;
  }

  if (props.navigation) {
    params.navigation = {
      nextEl: '.swiper-button-next.swiper-nav.d-none.d-lg-block',
      prevEl: '.swiper-button-prev.swiper-nav.d-none.d-lg-block',
    };
  }

  if (props.wrapperClass) {
    params.wrapperClass = `${params.wrapperClass} ${props.wrapperClass}`;
  }

  if (props.paginationClass) {
    params.pagination.el = `${params.containerClass} ${props.paginationClass}`;
  }

  if (props.pagination) {
    params.pagination = {
      el: `.swiper-pagination.${props.paginationClass}`,
      clickable: true,
      dynamicBullets: true,
    };
  }

  return props.data ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <swiper-container ref={swiperElRef} {...params}>
      {props.data.map((slide, index) => (
        <swiper-slide
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={`bg-cover ${
            slide.bgdirection ? `bg-cover-${slide.bgdirection}` : ''
          }`}
          style={{
            ...props.style,
            backgroundImage: !props.columns && `url(${slide.img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Container
            fluid={!props.columns}
            className={`h-100 ${!props.columns ? 'px-lg-6' : ''} ${
              props.containerclass ? props.containerclass : ''
            }`}
          >
            <Row
              className={`h-100 align-items-center ${
                slide.rowclass ? slide.rowclass : ''
              }`}
              data-swiper-parallax="-500"
            >
              {props.columns ? (
                <>
                  <Col
                    sm={6}
                    className={slide.contentclass ? slide.contentclass : ''}
                  >
                    {slide.subtitle && (
                      <p
                        className={`subtitle letter-spacing-3 fw-light ${
                          slide.subtitleclass ? slide.subtitleclass : ''
                        }`}
                      >
                        {slide.subtitle}
                      </p>
                    )}
                    <h2
                      className={slide.titleclass ? slide.titleclass : ''}
                      style={{ lineHeight: '1' }}
                    >
                      {slide.name}
                    </h2>
                    {slide.text && (
                      <p className="text-muted mb-5">{slide.text}</p>
                    )}
                    {slide.link && (
                      <Button color="outline-primary" href={slide.link}>
                        {slide.button}
                      </Button>
                    )}
                  </Col>
                  <Col sm={6} className="text-start text-sm-center">
                    <img
                      className="img-fluid home-slider-image"
                      src={slide.img}
                      alt=""
                      data-swiper-parallax="-200"
                    />
                    <Icon
                      icon="blob-shape-3"
                      className="svg-blob d-none d-md-inline-block svg-blob-fill-current svg-blob-swiper"
                      style={{ color: slide.color }}
                    />
                  </Col>
                </>
              ) : (
                <Col
                  lg={{ size: 6, offset: slide.contentoffset }}
                  className={slide.contentclass ? slide.contentclass : ''}
                >
                  {slide.subtitle && (
                    <p
                      className={`subtitle letter-spacing-3 fw-light ${
                        slide.subtitleclass ? slide.subtitleclass : ''
                      }`}
                    >
                      {slide.subtitle}
                    </p>
                  )}
                  <h2
                    className={slide.titleclass ? slide.titleclass : ''}
                    style={{ lineHeight: '1' }}
                  >
                    {slide.name}
                  </h2>
                  {slide.text && (
                    <p className="text-muted mb-5">{slide.text}</p>
                  )}
                  {slide.link && (
                    <Button color="dark" href={slide.link}>
                      {slide.button}
                    </Button>
                  )}
                </Col>
              )}
            </Row>
          </Container>
        </swiper-slide>
      ))}
    </swiper-container>
  ) : (
    'loading'
  );
};

FlaivySwiper.propTypes = {
  navigation: PropTypes.bool,
  className: PropTypes.string,
  containerclass: PropTypes.string,
  columns: PropTypes.string,
  slidesPerView: PropTypes.number,
  effect: PropTypes.string,
  allowTouchMove: PropTypes.bool,
  spaceBetween: PropTypes.number,
  centeredSlides: PropTypes.bool,
  roundLengths: PropTypes.string,
  loop: PropTypes.bool,
  speed: PropTypes.number,
  parallax: PropTypes.bool,
  autoplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  pagination: PropTypes.bool,
  paginationClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  data: PropTypes.array.isRequired,
  style: PropTypes.object,
};

FlaivySwiper.defaultProps = {
  navigation: true,
  className: undefined,
  containerclass: undefined,
  columns: undefined,
  xxxl: undefined,
  slidesPerView: undefined,
  effect: undefined,
  allowTouchMove: undefined,
  spaceBetween: undefined,
  centeredSlides: undefined,
  roundLengths: undefined,
  loop: true,
  speed: undefined,
  parallax: true,
  autoplay: true,
  autoplayDelay: 5000,
  pagination: undefined,
  paginationClass: undefined,
  wrapperClass: undefined,
  style: undefined,
};

export default FlaivySwiper;
